import { useState, useCallback } from 'react';

// Экспортируем глобальные переменные
export let globalToasts = [];
export let toastListeners = [];

const notifyListeners = () => {
  toastListeners.forEach(setter => setter([...globalToasts]));
};

export const createToast = (message, type = "success", duration = 5000) => {
  const id = Date.now();

  // ────────────────────────────────────────────────
  // Защита: приводим message к строке, обрабатываем типичные ошибки API
  // ────────────────────────────────────────────────
  let displayMessage = message;

  if (typeof message !== 'string') {
    if (message == null) {
      displayMessage = 'Неизвестная ошибка';
    }
    else if (typeof message === 'object') {
      // Pydantic / FastAPI single error
      if (message.msg) {
        displayMessage = message.msg;
        if (message.loc && Array.isArray(message.loc)) {
          displayMessage = `${message.loc.join(', ')}: ${message.msg}`;
        }
      }
      // FastAPI { detail: [...] } или { detail: string }
      else if (message.detail) {
        if (Array.isArray(message.detail)) {
          displayMessage = message.detail
            .map(item => {
              if (typeof item === 'string') return item;
              if (item.msg) {
                return item.loc ? `${item.loc.join(', ')}: ${item.msg}` : item.msg;
              }
              return JSON.stringify(item).slice(0, 200);
            })
            .filter(Boolean)
            .join(' • ') || 'Ошибка валидации';
        }
        else if (typeof message.detail === 'string') {
          displayMessage = message.detail;
        }
        else if (message.detail?.msg) {
          displayMessage = message.detail.msg;
        }
        else {
          displayMessage = JSON.stringify(message.detail).slice(0, 300) + '...';
        }
      }
      // Обычные JS-ошибки или другие объекты
      else if (message.message) {
        displayMessage = message.message;
      }
      else if (message.error) {
        displayMessage = message.error;
      }
      else {
        displayMessage = JSON.stringify(message).slice(0, 300) + '...';
      }
    }
    else {
      displayMessage = String(message);
    }
  }

  // Финальная страховка
  if (typeof displayMessage !== 'string') {
    displayMessage = 'Произошла ошибка';
  }

  // ────────────────────────────────────────────────
  // Обычная логика создания тоста
  // ────────────────────────────────────────────────
  const toastDetails = {
    success: { icon: "fa-circle-check" },
    error:   { icon: "fa-circle-xmark" },
    warning: { icon: "fa-circle-exclamation" },
    info:    { icon: "fa-circle-info" }
  };

  const { icon } = toastDetails[type] || toastDetails.success;

  const newToast = {
    id,
    type,
    icon,
    message: displayMessage,           // ← теперь всегда строка
    duration,
    timeoutId: setTimeout(() => removeToast(id), duration)
  };

  // Добавляем в начало (сверху) по умолчанию
  globalToasts = [newToast, ...globalToasts];

  // Если тип "bottom" — перемещаем в конец (будет снизу)
  if (type === "bottom") {
    globalToasts = [...globalToasts.slice(1), globalToasts[0]];
  }

  notifyListeners();

  return id;
};

const removeToast = (id) => {
  const toast = globalToasts.find(t => t.id === id);
  if (toast && toast.timeoutId) clearTimeout(toast.timeoutId);

  globalToasts = globalToasts.filter(t => t.id !== id);
  notifyListeners();
};

export default function useToast() {
  const [, setLocalToasts] = useState([]);

  useState(() => {
    toastListeners.push(setLocalToasts);
    return () => {
      toastListeners = toastListeners.filter(l => l !== setLocalToasts);
    };
  }, []);

  const toast = useCallback((message, type = "success", duration = 5000) => {
    createToast(message, type, duration);
  }, []);

  return toast;
}

export const removeToastById = (id) => removeToast(id);